export const BUILD_VERSION = 'c3e9fd52faf84113b5b660b25d130011342acefd';
